import { CategoryLists } from '@/models/CategoryKey';

export const ModelKey = {
  FHD01: 'FHD_DeskStationaryA',
  FHD02: 'FHD_DeskStationaryB',
  FHD03: 'FHD_DeskStationaryC',
  FHD04: 'FHD_CoinBankA',
  FHD05: 'FHD_CoinBankB',
  FHD06: 'FHD_CoinBankC',
  FHD07: 'FHD_CatTunnel',
  FHD08: 'FHD_BookShelf',
  FHD09: 'FHD_DeskShelf',
  FHD10: 'FHD_StorageBox',
  FHD11: 'FHD_TVConsole',
  FHD12: 'FHD_MagazineRack',
  FHD13: 'qled8k09_PolarBear',
  FHD14: 'qled8k10_SeaTurtle',
  FHD15: 'qled8k13_Tessellate',
  FHD16: 'qled8k14_Twist',
  FHD17: 'qled8k15_AlexCouchArmTable',
  FHD18: 'qled8k18_KinokoTable',
  FHD19: 'qled8k23_ToolBox',
  FHD20: 'FHD20_SixpackCarrier',
  FHD21: 'FHD21_Megaphone'
};

export default {
  categoryKey: CategoryLists.QLED.list.FHD,
  cover: {
    caption: 'LandingPage.FHD',
    backgroundImage: require('../../cover_image/cover_DeskStationarySet.jpg'),
    mobileCoverImage: require('../../cover_image/cover_DeskStationarySet.jpg'),
    mainImage: {
      src: require('../../../assets/categories/FHD.png'),
      pcSrc: require('../../../assets/categories/FHD.png'),
    },
  },
  box: {
    title: 'ProductPage.selectDesign', //i18n
    list: [
      {
        key: ModelKey.FHD01,
        image: {
          mobile: require('../../thumbnail/DeskStationaryA.png'),
          pc: require('../../thumbnail/DeskStationaryA.png'),
        },
        title: 'ProductPage.DeskStationary', // i18n
        text: 'A',
        level: 2,
        minutes: 50,
        allowInches: [32, 40],
      },
      {
        key: ModelKey.FHD02,
        image: {
          mobile: require('../../thumbnail/DeskStationaryB.png'),
          pc: require('../../thumbnail/DeskStationaryB.png'),
        },
        title: 'ProductPage.DeskStationary', // i18n
        text: 'B',
        level: 3,
        minutes: 60,
        allowInches: [32, 40],
      },
      {
        key: ModelKey.FHD03,
        image: {
          mobile: require('../../thumbnail/DeskStationaryC.png'),
          pc: require('../../thumbnail/DeskStationaryC.png'),
        },
        title: 'ProductPage.DeskStationary', // i18n
        text: 'C',
        level: 3,
        minutes: 60,
        allowInches: [32, 40],
      },
      {
        key: ModelKey.FHD04,
        image: {
          mobile: require('../../thumbnail/CoinBankA.png'),
          pc: require('../../thumbnail/CoinBankA.png'),
        },
        title: 'ProductPage.CoinBank', // i18n
        text: 'A',
        level: 2,
        minutes: 60,
        allowInches: [32, 40],
      },
      {
        key: ModelKey.FHD05,
        image: {
          mobile: require('../../thumbnail/CoinBankB.png'),
          pc: require('../../thumbnail/CoinBankB.png'),
        },
        title: 'ProductPage.CoinBank', // i18n
        text: 'B',
        level: 2,
        minutes: 60,
        allowInches: [32,40],
      },
      {
        key: ModelKey.FHD06,
        image: {
          mobile: require('../../thumbnail/CoinBankC.png'),
          pc: require('../../thumbnail/CoinBankC.png'),
        },
        title: 'ProductPage.CoinBank', // i18n
        text: 'C',
        level: 3,
        minutes: 60,
        allowInches: [32,40],
      },
      {
				key: ModelKey.FHD07,
				image: {
					mobile: require('../../thumbnail/cat_tunnel.png'),
					pc: require('../../thumbnail/cat_tunnel.png'),
				},
				title: 'ProductPage.CatTunnel', // i18n
				level: 2,
				minutes: 50,
				allowInches: [43],
			},
			{
				key: ModelKey.FHD08,
				image: {
					mobile: require('../../thumbnail/Book_shelf.png'),
					pc: require('../../thumbnail/Book_shelf.png'),
				},
				title: 'ProductPage.BookShelf', // i18n
				level: 2,
				minutes: 60,
				allowInches: [43],
			},
			{
				key: ModelKey.FHD09,
				image: {
					mobile: require('../../thumbnail/Desk_shelf.png'),
					pc: require('../../thumbnail/Desk_shelf.png'),
				},
				title: 'ProductPage.DeskShelf', // i18n
				level: 3,
				minutes: 80,
				allowInches: [43],
			},
			{
				key: ModelKey.FHD10,
				image: {
					mobile: require('../../thumbnail/Storagebox.png'),
					pc: require('../../thumbnail/Storagebox.png'),
				},
				title: 'ProductPage.StorageBox', // i18n
				level: 3,
				minutes: 120,
				allowInches: [43],
			},
			{
				key: ModelKey.FHD11,
				image: {
					mobile: require('../../thumbnail/tv_console.png'),
					pc: require('../../thumbnail/tv_console.png'),
				},
				title: 'ProductPage.tvConsole', // i18n
				level: 4,
				minutes: 180,
				allowInches: [43],
			},

			{
				key: ModelKey.FHD12,
				image: {
					mobile: require('../../thumbnail/Magazine_rack.png'),
					pc: require('../../thumbnail/Magazine_rack.png'),
				},
				title: 'ProductPage.MagazineRack', // i18n
				level: 4,
				minutes: 150,
				allowInches: [43],
			},
    ],
  },
  dezeenBox: {
		title: 'ProductPage.selectDesignDezeen', //i18n
		list: [
			{
				key: ModelKey.FHD13,
				image: {
				mobile: require('../../thumbnail/Endangered_Animals_bear.png'),
				pc: require('../../thumbnail/Endangered_Animals_bear.png'),
			},
				title: 'ProductPage.PolarBear', // i18n
				allowInches: [43],
			},
			{
				key: ModelKey.FHD14,
				image: {
				mobile: require('../../thumbnail/Endangered_Animals_turtle.png'),
				pc: require('../../thumbnail/Endangered_Animals_turtle.png'),
			},
				title: 'ProductPage.SeaTurtle', // i18n
				allowInches: [43],
			},
			{
				key: ModelKey.FHD15,
				image: {
				mobile: require('../../thumbnail/Tessellate.png'),
				pc: require('../../thumbnail/Tessellate.png'),
			},
				title: 'ProductPage.Tessellate', // i18n
				allowInches: [43],
			},
			{
				key: ModelKey.FHD16,
				image: {
				mobile: require('../../thumbnail/Twist.png'),
				pc: require('../../thumbnail/Twist.png'),
			},
				title: 'ProductPage.Twist', // i18n
				allowInches: [43],
			},
			{
				key: ModelKey.FHD17,
				image: {
				mobile: require('../../thumbnail/Alex_couch_arm_table.png'),
				pc: require('../../thumbnail/Alex_couch_arm_table.png'),
			},
				title: 'ProductPage.AlexCouchArmTable', // i18n
				allowInches: [43],
			},
      {
				key: ModelKey.FHD18,
				image: {
				mobile: require('../../thumbnail/Kinokotable.png'),
				pc: require('../../thumbnail/Kinokotable.png'),
			},
				title: 'ProductPage.KinokoTable', // i18n
				allowInches: [43],
			},
			{
				key: ModelKey.FHD19,
				image: {
				mobile: require('../../thumbnail/Toolbox.png'),
				pc: require('../../thumbnail/Toolbox.png'),
				},
				title: 'ProductPage.ToolBox', // i18n
				allowInches: [43],
			},
		],
	},
	worldcup:{
		title: 'ProductPage.selectDesignSoccer', //i18n
		list: [
			{
				key: ModelKey.FHD20,
				image: {
				mobile: require('../../thumbnail/sixpackcarrier.png'),
				pc: require('../../thumbnail/sixpackcarrier.png'),
				},
				title: 'ProductPage.sixpackcarrier', // i18n
				allowInches: [43],
			},
			{
				key: ModelKey.FHD21,
				image: {
				mobile: require('../../thumbnail/megaphone.png'),
				pc: require('../../thumbnail/megaphone.png'),
				},
				title: 'ProductPage.megaphone', // i18n
				allowInches: [43],
			},
		]
	},
	disney:{},
  ModelKey: ModelKey,
};

export const Boxes = {
  [ModelKey.FHD01]: () => import('./deskstationeryA'),
  [ModelKey.FHD02]: () => import('./deskstationeryB'),
  [ModelKey.FHD03]: () => import('./deskstationeryC'),
  [ModelKey.FHD04]: () => import('./coinbankA'),
  [ModelKey.FHD05]: () => import('./coinbankB'),
  [ModelKey.FHD06]: () => import('./coinbankC'),
  [ModelKey.FHD07]: () => import('./cattunnel'),
  [ModelKey.FHD08]: () => import('./bookshelf'),
  [ModelKey.FHD09]: () => import('./deskshelf'),
  [ModelKey.FHD10]: () => import('./storagebox'),
  [ModelKey.FHD11]: () => import('./tvconsole'),
  [ModelKey.FHD12]: () => import('./magazinerack'),
  [ModelKey.FHD13]: () => import('./polarbear'),
  [ModelKey.FHD14]: () => import('./turtle'),
  [ModelKey.FHD15]: () => import('./tessellate'),
  [ModelKey.FHD16]: () => import('./twist'),
  [ModelKey.FHD17]: () => import('./armtable'),
  [ModelKey.FHD18]: () => import('./kinokotable'),
  [ModelKey.FHD19]: () => import('./toolbox'),
  [ModelKey.FHD20]: () => import('./sixpackcarrier'),
  [ModelKey.FHD21]: () => import('./megaphone'),
};